/**
 * Maps auth-js error codes — from a dead invite/recovery link, or a failed
 * manual token exchange — to a user-facing message. Codes that indicate the
 * link itself is no longer valid get specific copy; anything else (including
 * missing/unrecognized codes) falls back to a generic retry message.
 */
const LINK_ERROR_MESSAGES: Record<string, string> = {
  otp_expired: "This link has expired. Request a new one.",
  flow_state_not_found: "This link is no longer valid. Request a new one.",
  flow_state_expired: "This link is no longer valid. Request a new one.",
  bad_code_verifier: "This link is no longer valid. Request a new one.",
  refresh_token_not_found: "This link is no longer valid. Request a new one.",
  refresh_token_already_used: "This link is no longer valid. Request a new one.",
  session_expired: "This link is no longer valid. Request a new one.",
};

const GENERIC_LINK_ERROR =
  "Something went wrong confirming this link. Please try again, or request a new one if the problem continues.";

export const getAuthLinkErrorMessage = (errorCode?: string | null): string => {
  if (errorCode && LINK_ERROR_MESSAGES[errorCode]) {
    return LINK_ERROR_MESSAGES[errorCode];
  }
  if (errorCode) {
    // Unrecognized (but present) code — log it so new Supabase error codes are discoverable.
    console.error("[authLinkError] Unrecognized auth-link error code:", errorCode);
  }
  return GENERIC_LINK_ERROR;
};

/** Returns an error message from the URL hash if an auth-link error is present, or null on a plain visit. */
export const parseAuthLinkError = (hash: string): string | null => {
  const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
  const errorCode = params.get("error_code");
  if (!errorCode && !params.get("error")) {
    return null;
  }
  return getAuthLinkErrorMessage(errorCode);
};
